import React from 'react';
import { TextField } from '@mui/material';
import { useBuilderContext, useField } from '../../context';

export const CampaignNameField: React.FC = () => {
  const { value, error, onChange, onBlur } = useField('name');
  const { config, isCampaignReadOnly } = useBuilderContext();

  return (
    <TextField
      sx={{ mt: config.type === 'reminder' ? 1.25 : 0, mb: 1.25 }}
      id="outlined-basic"
      label="Campaign Name"
      name="name"
      variant="outlined"
      disabled={isCampaignReadOnly}
      value={value ?? ''}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      error={!!error}
      helperText={error ?? ''}
    />
  );
};
